import React from 'react';

function Footer(props) {
    return (
        <footer>
              تمامی حقوق مادی و معنوی این سایت متعلق به محمد رضا دهباشی زاده می‌باشد . © 1402 
        </footer>
    );
}

export default Footer;